<script setup>
import { Link } from '@inertiajs/vue3';
import { ref, onMounted, onUnmounted } from 'vue';

const isFooterVisible = ref(window.innerWidth > 600);

const isLink1 = ref(false);
const isLink2 = ref(false);
const isLink3 = ref(false);
const isLink4 = ref(false);

function checkWidth() {
    isFooterVisible.value = window.innerWidth > 600;
}

onMounted(() => {
    window.addEventListener('resize', checkWidth);

    isLink1.value = (window.location.pathname === '/home')
    isLink2.value = (window.location.pathname === '/kunjungan')
    isLink3.value = (window.location.pathname === '/tagihan')
    isLink4.value = (window.location.pathname === '/clientlog')
});

onUnmounted(() => {
    window.removeEventListener('resize', checkWidth);
});
</script>

<template>
    <footer class="main-footer">
        <strong>Copyright &copy; 2014.</strong> All rights reserved.
        <div class="float-right d-none d-sm-inline">
            Template by <a href="javascript:void(0)">AdminLTE.io</a>
        </div>
    </footer>
    <!-- <footer class="main-footer"
        style="position: fixed;right: 0;bottom: 0;left:0;z-index:10000; padding-top: 0rem;padding-bottom: 0rem;" v-else>
        <div class="row">
            <div class="col">
                <a class="btn btn-block" href="/home"><i class="fas fa-tachometer-alt"
                        :style="{ color: isLink1 ? 'blue' : '' }"></i><br><b
                        :style="{ 'font-size': '12px', color: isLink1 ? 'blue' : '' }">Dashboard</b></a>
            </div>
            <div class="col">
                <a class="btn btn-block" href="/kunjungan"><i class="fas fa-biking"
                        :style="{ color: isLink2 ? 'blue' : '' }"></i><br><b
                        :style="{ 'font-size': '12px', color: isLink2 ? 'blue' : '' }">Kunjungan</b>
                </a>
            </div>
            <div class="col">
                <a class="btn btn-block" href="/tagihan"><i class="fas fa-address-book"
                        :style="{ color: isLink3 ? 'blue' : '' }"></i><br><b
                        :style="{ 'font-size': '12px', color: isLink3 ? 'blue' : '' }">Tagihan</b></a>
            </div>
            <div class="col">
                <a class="btn btn-block" href="/clientlog"><i class="fa fa-wave-square"
                        :style="{ color: isLink4 ? 'blue' : '' }"></i><br><b
                        :style="{ 'font-size': '12px', color: isLink4 ? 'blue' : '' }">Activity</b></a>
            </div>
        </div>
    </footer> -->
</template>